import { EmailSendService } from '@weave/schema-gen-ts/dist/schemas/email/send/v2/send_service.pb';
import { bindHTTP } from '@frontend/schema';

export const SchemaEmailSendV2Service = bindHTTP(EmailSendService);
export const serviceName = 'email-send-v2' as const;
